import { Box, Grid, TextField, Typography } from "@mui/material";

const RenderConditionDetail = ({ title = "", type, data, loading }) => {
  console.log({ data });
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      <Typography variant="h5">
        {title ? title : type === "consignment_car" ? "เงื่อนไขการฝากขาย" : ""}
      </Typography>
      {data && data.consignment_detail && (
        <Grid container spacing={2} sx={{ pl: 2 }}>
          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} sm={2}>
                <Typography variant="body1">ราคารถ</Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <TextField
                  fullWidth
                  variant="outlined"
                  name="car_price"
                  placeholder="ระบุราคารถ"
                  type="number"
                  value={data.consignment_detail.setting_price}
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body1">บาท</Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} sm={2}>
                <Typography variant="body1">ค่าบริการ</Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <TextField
                  fullWidth
                  variant="outlined"
                  name="percent_for_sale"
                  placeholder="ระบุค่าบริการ"
                  type="number"
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={data.consignment_detail.percent_for_sale}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body1">%</Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} sm={2}>
                <Typography variant="body1">ราคารถสุทธิ</Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <TextField
                  fullWidth
                  variant="outlined"
                  name="total_price"
                  placeholder="กรุณากรอกราคารถสุทธิ"
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      bgcolor: "white",
                      height: "40px",
                    },
                  }}
                  value={data.consignment_detail.total_price}
                />
              </Grid>
              <Grid item xs={12} sm={1}>
                <Typography variant="body1">บาท</Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default RenderConditionDetail;
